/**
 * SM4 国密算法纯JavaScript实现 (CBC模式)
 * 与Java后端 BouncyCastle SM4/CBC/PKCS5Padding 兼容
 */

// S盒
const SBOX = [
  0xd6, 0x90, 0xe9, 0xfe, 0xcc, 0xe1, 0x3d, 0xb7, 0x16, 0xb6, 0x14, 0xc2, 0x28, 0xfb, 0x2c, 0x05,
  0x2b, 0x67, 0x9a, 0x76, 0x2a, 0xbe, 0x04, 0xc3, 0xaa, 0x44, 0x13, 0x26, 0x49, 0x86, 0x06, 0x99,
  0x9c, 0x42, 0x50, 0xf4, 0x91, 0xef, 0x98, 0x7a, 0x33, 0x54, 0x0b, 0x43, 0xed, 0xcf, 0xac, 0x62,
  0xe4, 0xb3, 0x1c, 0xa9, 0xc9, 0x08, 0xe8, 0x95, 0x80, 0xdf, 0x94, 0xfa, 0x75, 0x8f, 0x3f, 0xa6,
  0x47, 0x07, 0xa7, 0xfc, 0xf3, 0x73, 0x17, 0xba, 0x83, 0x59, 0x3c, 0x19, 0xe6, 0x85, 0x4f, 0xa8,
  0x68, 0x6b, 0x81, 0xb2, 0x71, 0x64, 0xda, 0x8b, 0xf8, 0xeb, 0x0f, 0x4b, 0x70, 0x56, 0x9d, 0x35,
  0x1e, 0x24, 0x0e, 0x5e, 0x63, 0x58, 0xd1, 0xa2, 0x25, 0x22, 0x7c, 0x3b, 0x01, 0x21, 0x78, 0x87,
  0xd4, 0x00, 0x46, 0x57, 0x9f, 0xd3, 0x27, 0x52, 0x4c, 0x36, 0x02, 0xe7, 0xa0, 0xc4, 0xc8, 0x9e,
  0xea, 0xbf, 0x8a, 0xd2, 0x40, 0xc7, 0x38, 0xb5, 0xa3, 0xf7, 0xf2, 0xce, 0xf9, 0x61, 0x15, 0xa1,
  0xe0, 0xae, 0x5d, 0xa4, 0x9b, 0x34, 0x1a, 0x55, 0xad, 0x93, 0x32, 0x30, 0xf5, 0x8c, 0xb1, 0xe3,
  0x1d, 0xf6, 0xe2, 0x2e, 0x82, 0x66, 0xca, 0x60, 0xc0, 0x29, 0x23, 0xab, 0x0d, 0x53, 0x4e, 0x6f,
  0xd5, 0xdb, 0x37, 0x45, 0xde, 0xfd, 0x8e, 0x2f, 0x03, 0xff, 0x6a, 0x72, 0x6d, 0x6c, 0x5b, 0x51,
  0x8d, 0x1b, 0xaf, 0x92, 0xbb, 0xdd, 0xbc, 0x7f, 0x11, 0xd9, 0x5c, 0x41, 0x1f, 0x10, 0x5a, 0xd8,
  0x0a, 0xc1, 0x31, 0x88, 0xa5, 0xcd, 0x7b, 0xbd, 0x2d, 0x74, 0xd0, 0x12, 0xb8, 0xe5, 0xb4, 0xb0,
  0x89, 0x69, 0x97, 0x4a, 0x0c, 0x96, 0x77, 0x7e, 0x65, 0xb9, 0xf1, 0x09, 0xc5, 0x6e, 0xc6, 0x84,
  0x18, 0xf0, 0x7d, 0xec, 0x3a, 0xdc, 0x4d, 0x20, 0x79, 0xee, 0x5f, 0x3e, 0xd7, 0xcb, 0x39, 0x48
];

const FK = [0xa3b1bac6, 0x56aa3350, 0x677d9197, 0xb27022dc];
const CK = [
  0x00070e15, 0x1c232a31, 0x383f464d, 0x545b6269, 0x70777e85, 0x8c939aa1, 0xa8afb6bd, 0xc4cbd2d9,
  0xe0e7eef5, 0xfc030a11, 0x181f262d, 0x343b4249, 0x50575e65, 0x6c737a81, 0x888f969d, 0xa4abb2b9,
  0xc0c7ced5, 0xdce3eaf1, 0xf8ff060d, 0x141b2229, 0x30373e45, 0x4c535a61, 0x686f767d, 0x848b9299,
  0xa0a7aeb5, 0xbcc3cad1, 0xd8dfe6ed, 0xf4fb0209, 0x10171e25, 0x2c333a41, 0x484f565d, 0x646b7279
];

function sm4Sbox(inch) {
  return SBOX[inch];
}

function sm4Lt(ka) {
  let bb = 0, c = 0;
  const a = new Array(4);
  const b = new Array(4);
  a[0] = (ka & 0xff000000) >>> 24;
  a[1] = (ka & 0x00ff0000) >>> 16;
  a[2] = (ka & 0x0000ff00) >>> 8;
  a[3] = (ka & 0x000000ff);
  b[0] = sm4Sbox(a[0]);
  b[1] = sm4Sbox(a[1]);
  b[2] = sm4Sbox(a[2]);
  b[3] = sm4Sbox(a[3]);
  bb = (b[0] << 24) | (b[1] << 16) | (b[2] << 8) | (b[3]);
  c = bb ^ ((bb << 2) | (bb >>> 30)) ^ ((bb << 10) | (bb >>> 22)) ^ ((bb << 18) | (bb >>> 14)) ^ ((bb << 24) | (bb >>> 8));
  return c >>> 0;
}

function sm4F(x0, x1, x2, x3, rk) {
  return (x0 ^ sm4Lt(x1 ^ x2 ^ x3 ^ rk)) >>> 0;
}

function sm4CalciRK(ka) {
  let bb = 0, c = 0;
  const a = new Array(4), b = new Array(4);
  a[0] = (ka & 0xff000000) >>> 24;
  a[1] = (ka & 0x00ff0000) >>> 16;
  a[2] = (ka & 0x0000ff00) >>> 8;
  a[3] = (ka & 0x000000ff);
  b[0] = sm4Sbox(a[0]);
  b[1] = sm4Sbox(a[1]);
  b[2] = sm4Sbox(a[2]);
  b[3] = sm4Sbox(a[3]);
  bb = (b[0] << 24) | (b[1] << 16) | (b[2] << 8) | (b[3]);
  c = bb ^ ((bb << 13) | (bb >>> 19)) ^ ((bb << 23) | (bb >>> 9));
  return c >>> 0;
}

function sm4_setkey(MK) {
  const K = new Array(36);
  const rk = new Array(32);
  K[0] = (MK[0] ^ FK[0]) >>> 0;
  K[1] = (MK[1] ^ FK[1]) >>> 0;
  K[2] = (MK[2] ^ FK[2]) >>> 0;
  K[3] = (MK[3] ^ FK[3]) >>> 0;
  for (let i = 0; i < 32; i++) {
    K[i + 4] = (K[i] ^ sm4CalciRK(K[i + 1] ^ K[i + 2] ^ K[i + 3] ^ CK[i])) >>> 0;
    rk[i] = K[i + 4];
  }
  return rk;
}

function sm4_crypt_ecb_block(rk, input, output) {
  let X = new Array(36);
  const ulbuf = new Array(36);
  X[0] = ((input[0] & 0xff) << 24) | ((input[1] & 0xff) << 16) | ((input[2] & 0xff) << 8) | (input[3] & 0xff);
  X[1] = ((input[4] & 0xff) << 24) | ((input[5] & 0xff) << 16) | ((input[6] & 0xff) << 8) | (input[7] & 0xff);
  X[2] = ((input[8] & 0xff) << 24) | ((input[9] & 0xff) << 16) | ((input[10] & 0xff) << 8) | (input[11] & 0xff);
  X[3] = ((input[12] & 0xff) << 24) | ((input[13] & 0xff) << 16) | ((input[14] & 0xff) << 8) | (input[15] & 0xff);
  for (let i = 0; i < 32; i++) {
    X[i + 4] = sm4F(X[i], X[i + 1], X[i + 2], X[i + 3], rk[i]);
  }
  output[0] = (X[35] >>> 24) & 0xff; output[1] = (X[35] >>> 16) & 0xff; output[2] = (X[35] >>> 8) & 0xff; output[3] = X[35] & 0xff;
  output[4] = (X[34] >>> 24) & 0xff; output[5] = (X[34] >>> 16) & 0xff; output[6] = (X[34] >>> 8) & 0xff; output[7] = X[34] & 0xff;
  output[8] = (X[33] >>> 24) & 0xff; output[9] = (X[33] >>> 16) & 0xff; output[10] = (X[33] >>> 8) & 0xff; output[11] = X[33] & 0xff;
  output[12] = (X[32] >>> 24) & 0xff; output[13] = (X[32] >>> 16) & 0xff; output[14] = (X[32] >>> 8) & 0xff; output[15] = X[32] & 0xff;
}

function pkcs7Padding(data) {
  const blockSize = 16;
  const padLen = blockSize - (data.length % blockSize);
  const padding = new Array(padLen).fill(padLen);
  return data.concat(padding);
}

function pkcs7Unpad(data) {
  const padLen = data[data.length - 1];
  if (padLen < 1 || padLen > 16) return data;
  for (let i = data.length - padLen; i < data.length; i++) {
    if (data[i] !== padLen) return data;
  }
  return data.slice(0, data.length - padLen);
}

function xorBlock(a, b) {
  const result = new Array(16);
  for (let i = 0; i < 16; i++) result[i] = a[i] ^ b[i];
  return result;
}

/**
 * Hex字符串转字节数组
 */
function hexToBytes(hex) {
  const bytes = [];
  for (let i = 0; i < hex.length; i += 2) {
    bytes.push(parseInt(hex.substr(i, 2), 16));
  }
  return bytes;
}

/**
 * Base64解码 → 字节数组
 */
function base64ToBytes(base64) {
  const binary = atob(base64);
  const bytes = [];
  for (let i = 0; i < binary.length; i++) {
    bytes.push(binary.charCodeAt(i) & 0xff);
  }
  return bytes;
}

/**
 * 字节数组 → UTF-8字符串
 */
function bytesToUtf8(bytes) {
  let result = '';
  let i = 0;
  while (i < bytes.length) {
    const b = bytes[i];
    if (b <= 0x7f) {
      result += String.fromCharCode(b);
      i += 1;
    } else if (b >= 0xc0 && b <= 0xdf) {
      result += String.fromCharCode(((b & 0x1f) << 6) | (bytes[i + 1] & 0x3f));
      i += 2;
    } else if (b >= 0xe0 && b <= 0xef) {
      result += String.fromCharCode(((b & 0x0f) << 12) | ((bytes[i + 1] & 0x3f) << 6) | (bytes[i + 2] & 0x3f));
      i += 3;
    } else {
      i += 1;
    }
  }
  return result;
}

// ==================== SHA-256 纯JS实现 ====================

const SHA256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function sha256ROR(n, d) { return ((n >>> d) | (n << (32 - d))) >>> 0; }
function sha256CH(x, y, z) { return ((x & y) ^ (~x & z)) >>> 0; }
function sha256MAJ(x, y, z) { return ((x & y) ^ (x & z) ^ (y & z)) >>> 0; }
function sha256BSIG0(x) { return (sha256ROR(x, 2) ^ sha256ROR(x, 13) ^ sha256ROR(x, 22)) >>> 0; }
function sha256BSIG1(x) { return (sha256ROR(x, 6) ^ sha256ROR(x, 11) ^ sha256ROR(x, 25)) >>> 0; }
function sha256SSIG0(x) { return (sha256ROR(x, 7) ^ sha256ROR(x, 18) ^ (x >>> 3)) >>> 0; }
function sha256SSIG1(x) { return (sha256ROR(x, 17) ^ sha256ROR(x, 19) ^ (x >>> 10)) >>> 0; }

/**
 * SHA-256 哈希，输入 UTF-8 字符串，返回 64 位 Hex 字符串
 */
export function sha256(input) {
  // UTF-8 编码
  const msgBytes = [];
  for (let i = 0; i < input.length; i++) {
    const code = input.charCodeAt(i);
    if (code <= 0x7f) msgBytes.push(code);
    else if (code <= 0x7ff) { msgBytes.push(0xc0 | (code >> 6)); msgBytes.push(0x80 | (code & 0x3f)); }
    else { msgBytes.push(0xe0 | (code >> 12)); msgBytes.push(0x80 | ((code >> 6) & 0x3f)); msgBytes.push(0x80 | (code & 0x3f)); }
  }

  const bitLen = msgBytes.length * 8;
  // Padding: append 0x80, then 0x00 until length % 64 == 56, then 64-bit big-endian length
  msgBytes.push(0x80);
  while ((msgBytes.length % 64) !== 56) msgBytes.push(0x00);
  for (let i = 7; i >= 0; i--) msgBytes.push((bitLen >>> (i * 8)) & 0xff);

  // 初始哈希值
  const H = [0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19];

  // 处理每个 512-bit 块
  for (let i = 0; i < msgBytes.length; i += 64) {
    const W = new Array(64);
    for (let t = 0; t < 16; t++) {
      W[t] = (msgBytes[i + t * 4] << 24) | (msgBytes[i + t * 4 + 1] << 16) | (msgBytes[i + t * 4 + 2] << 8) | msgBytes[i + t * 4 + 3];
    }
    for (let t = 16; t < 64; t++) {
      W[t] = (sha256SSIG1(W[t - 2]) + W[t - 7] + sha256SSIG0(W[t - 15]) + W[t - 16]) >>> 0;
    }

    let [a, b, c, d, e, f, g, h] = H;
    for (let t = 0; t < 64; t++) {
      const T1 = (h + sha256BSIG1(e) + sha256CH(e, f, g) + SHA256_K[t] + W[t]) >>> 0;
      const T2 = (sha256BSIG0(a) + sha256MAJ(a, b, c)) >>> 0;
      h = g; g = f; f = e; e = (d + T1) >>> 0;
      d = c; c = b; b = a; a = (T1 + T2) >>> 0;
    }
    H[0] = (H[0] + a) >>> 0; H[1] = (H[1] + b) >>> 0; H[2] = (H[2] + c) >>> 0; H[3] = (H[3] + d) >>> 0;
    H[4] = (H[4] + e) >>> 0; H[5] = (H[5] + f) >>> 0; H[6] = (H[6] + g) >>> 0; H[7] = (H[7] + h) >>> 0;
  }

  // 输出 64 位 Hex
  let hex = '';
  for (let i = 0; i < 8; i++) {
    hex += ((H[i] >>> 24) & 0xff).toString(16).padStart(2, '0');
    hex += ((H[i] >>> 16) & 0xff).toString(16).padStart(2, '0');
    hex += ((H[i] >>> 8) & 0xff).toString(16).padStart(2, '0');
    hex += (H[i] & 0xff).toString(16).padStart(2, '0');
  }
  return hex;
}

// ==================== 动态密钥派生 ====================

/**
 * 根据用户 Token 直接获取 SM4 动态密钥（与后端 SM4Util.deriveKey 一致）
 * Token 本身是 32 位 UUID（无短横线），即 32 Hex = 128 位 SM4 密钥
 */
export function deriveKey(token) {
  // Token 本身就是 32 位 Hex 字符串，直接用作 SM4 密钥
  if (token.length >= 32) return token.substring(0, 32);
  // 短 token 补齐到 32 字符（极少情况）
  return (token + '00000000000000000000000000000000').substring(0, 32);
}

// ==================== SM4-CBC 加密（带指定密钥） ====================

/**
 * SM4-CBC 加密（使用指定密钥）
 * @param {string} plainText 明文字符串
 * @param {string} keyHex 32位 Hex 密钥
 * @returns {string} Base64 编码的密文
 */
export function sm4EncryptWithKey(plainText, keyHex) {
  const keyBytes = hexToBytes(keyHex);
  const rk = sm4_setkey([
    (keyBytes[0] << 24) | (keyBytes[1] << 16) | (keyBytes[2] << 8) | keyBytes[3],
    (keyBytes[4] << 24) | (keyBytes[5] << 16) | (keyBytes[6] << 8) | keyBytes[7],
    (keyBytes[8] << 24) | (keyBytes[9] << 16) | (keyBytes[10] << 8) | keyBytes[11],
    (keyBytes[12] << 24) | (keyBytes[13] << 16) | (keyBytes[14] << 8) | keyBytes[15]
  ]);

  // UTF-8 编码
  const plainBytes = [];
  for (let i = 0; i < plainText.length; i++) {
    const code = plainText.charCodeAt(i);
    if (code <= 0x7f) plainBytes.push(code);
    else if (code <= 0x7ff) { plainBytes.push(0xc0 | (code >> 6)); plainBytes.push(0x80 | (code & 0x3f)); }
    else { plainBytes.push(0xe0 | (code >> 12)); plainBytes.push(0x80 | ((code >> 6) & 0x3f)); plainBytes.push(0x80 | (code & 0x3f)); }
  }

  const padded = pkcs7Padding(plainBytes);
  let prevBlock = [...IV_BYTES];
  const cipherBytes = [];

  for (let i = 0; i < padded.length; i += 16) {
    const block = padded.slice(i, i + 16);
    const xored = xorBlock(block, prevBlock);
    const encrypted = new Array(16);
    sm4_crypt_ecb_block(rk, xored, encrypted);
    prevBlock = encrypted;
    for (let j = 0; j < 16; j++) cipherBytes.push(encrypted[j]);
  }

  return bytesToBase64(cipherBytes);
}

// ==================== SM4-CBC 解密（带指定密钥） ====================

/**
 * SM4-CBC 解密（使用指定密钥）
 * @param {string} cipherBase64 Base64 编码的密文
 * @param {string} keyHex 32位 Hex 密钥
 * @returns {string} 明文字符串
 */
export function sm4Decrypt(cipherBase64, keyHex) {
  const cipherBytes = base64ToBytes(cipherBase64);
  const keyBytes = hexToBytes(keyHex);
  const rk = sm4_setkey([
    (keyBytes[0] << 24) | (keyBytes[1] << 16) | (keyBytes[2] << 8) | keyBytes[3],
    (keyBytes[4] << 24) | (keyBytes[5] << 16) | (keyBytes[6] << 8) | keyBytes[7],
    (keyBytes[8] << 24) | (keyBytes[9] << 16) | (keyBytes[10] << 8) | keyBytes[11],
    (keyBytes[12] << 24) | (keyBytes[13] << 16) | (keyBytes[14] << 8) | keyBytes[15]
  ]);

  let prevBlock = [...IV_BYTES];
  const plainBytes = [];

  // SM4 解密使用反向轮密钥（rk[31] → rk[0]），与 BouncyCastle Cipher.DECRYPT_MODE 一致
  const rkDecrypt = new Array(32);
  for (let i = 0; i < 32; i++) {
    rkDecrypt[i] = rk[31 - i];
  }

  for (let i = 0; i < cipherBytes.length; i += 16) {
    const block = cipherBytes.slice(i, i + 16);
    const decrypted = new Array(16);
    sm4_crypt_ecb_block(rkDecrypt, block, decrypted);
    const xored = xorBlock(decrypted, prevBlock);
    prevBlock = block;
    for (let j = 0; j < 16; j++) plainBytes.push(xored[j]);
  }

  // PKCS7 去填充 + UTF-8 解码
  const unpadded = pkcs7Unpad(plainBytes);
  return bytesToUtf8(unpadded);
}

// ==================== 向后兼容的静态密钥模式 ====================

// SM4密钥（16字节=128位，Hex编码，与后端保持一致）
let SECRET_KEY_HEX = '0123456789ABCDEFFEDCBA9876543210';

// IV向量（与后端保持一致）
const IV_BYTES = [0x30, 0x31, 0x32, 0x33, 0x34, 0x35, 0x36, 0x37, 0x38, 0x39, 0x41, 0x42, 0x43, 0x44, 0x45, 0x46];

/**
 * 字节数组转Base64
 */
function bytesToBase64(bytes) {
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

/**
 * SM4-CBC 加密（使用静态密钥，向后兼容）
 * @param {string} plainText 明文
 * @returns {string} Base64编码的密文
 */
export function sm4Encrypt(plainText) {
  return sm4EncryptWithKey(plainText, SECRET_KEY_HEX);
}

/**
 * 设置SM4密钥
 */
export function setSM4Key(keyHex) {
  if (keyHex && keyHex.length === 32) {
    SECRET_KEY_HEX = keyHex;
  }
}

export default { sm4Encrypt, sm4EncryptWithKey, sm4Decrypt, setSM4Key, deriveKey, sha256 };
